import { Module, VuexModule, Mutation } from 'vuex-module-decorators'
import { DownloadsSubscription } from '~/graphql/types'

@Module({
  name: 'file-download',
  stateFactory: true,
  namespaced: true,
})
export default class FileDownload extends VuexModule {
  loading = true
  updating = true
  items: DownloadsSubscription['download'] = []
  fetchStarted = false

  @Mutation
  setLoading(loading) {
    this.loading = loading
  }

  @Mutation
  setUpdating(updating) {
    this.updating = updating
  }

  @Mutation
  setItems(items) {
    this.items = items
  }

  @Mutation
  setFetchStarted(fetchStarted) {
    this.fetchStarted = fetchStarted
  }
}
